/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { fetchGraphQl } from '@/quote-management/api';
import { GENERATE_NEGOTIABLE_QUOTE_FROM_TEMPLATE_MUTATION } from './graphql/generateNegotiableQuoteFromTemplate';
import { state } from '@/quote-management/lib/state';
import { events } from '@adobe-commerce/event-bus';

export interface GenerateQuoteFromTemplateParams {
  templateId: string;
}

export const generateQuoteFromTemplate = async (
  params: GenerateQuoteFromTemplateParams
) => {
  if (!params.templateId) {
    throw new Error('Template ID is required');
  }

  if (!state.authenticated) {
    throw new Error('Unauthorized');
  }

  try {
    const results: any = await fetchGraphQl(
      GENERATE_NEGOTIABLE_QUOTE_FROM_TEMPLATE_MUTATION,
      {
        variables: {
          input: {
            template_id: params.templateId,
          },
        },
      }
    );

    if (
      !results?.data?.generateNegotiableQuoteFromTemplate?.negotiable_quote_uid
    ) {
      throw new Error('No quote UID received');
    }

    const quoteId =
      results.data.generateNegotiableQuoteFromTemplate.negotiable_quote_uid;

    events.emit('quote-management/quote-template-generated', {
      quoteId,
    });

    return { quoteId };
  } catch (error) {
    return Promise.reject(error);
  }
};
